import { createReducer } from "utils/redux";

export const MARKET_PRICE_QUERY_LIST_SUCCESS = 'MARKET_PRICE_QUERY_LIST_SUCCESS';
export const MARKET_PRICE_QUERY_LIST_FAILED = 'MARKET_PRICE_QUERY_LIST_FAILED';

export const MarketPriceList = createReducer(
  MARKET_PRICE_QUERY_LIST_SUCCESS,
  MARKET_PRICE_QUERY_LIST_FAILED
);